import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerClinic } from '../api/registration';

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    clinic_name: '',
    domain: '',
    contact_email: '',
    contact_phone: '',
    api_key: '',
    user_email: '',
    user_password: '',
    user_name: '',
    timezone: 'UTC',
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await registerClinic(formData);
      navigate('/signup-success');
    } catch (err) {
      setError(err.response?.data?.detail || 'Signup failed');
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '2rem' }}>
      <h1 style={{ marginBottom: '1.5rem' }}>Sign Up Your Clinic</h1>
      <form onSubmit={handleSubmit}>
        <h3>Clinic Info</h3>
        {[
          ['clinic_name', 'Clinic Name'],
          ['domain', 'Domain (optional)'],
          ['contact_email', 'Contact Email (optional)'],
          ['contact_phone', 'Contact Phone (optional)'],
          ['api_key', 'Pabau API Key (optional)'],
        ].map(([name, placeholder]) => (
          <div key={name} style={{ marginBottom: '1rem' }}>
            <input
              name={name}
              placeholder={placeholder}
              onChange={handleChange}
              required={['clinic_name'].includes(name)}
              style={{ width: '100%', padding: '0.5rem' }}
            />
          </div>
        ))}

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.25rem', fontWeight: 'bold' }}>
            Timezone
          </label>
          <select
            name="timezone"
            value={formData.timezone}
            onChange={handleChange}
            style={{ width: '100%', padding: '0.5rem' }}
          >
            <option value="UTC">UTC</option>
            <option value="Europe/London">London (GMT/BST)</option>
            <option value="Europe/Dublin">Dublin (GMT/IST)</option>
            <option value="America/New_York">New York (EST/EDT)</option>
            <option value="America/Los_Angeles">Los Angeles (PST/PDT)</option>
            <option value="Australia/Sydney">Sydney (AEST/AEDT)</option>
          </select>
        </div>

        <h3>User Info</h3>
        {[
          ['user_name', 'Full Name'],
          ['user_email', 'Email'],
          ['user_password', 'Password'],
        ].map(([name, placeholder]) => (
          <div key={name} style={{ marginBottom: '1rem' }}>
            <input
              name={name}
              type={name.includes('password') ? 'password' : name.includes('email') ? 'email' : 'text'}
              placeholder={placeholder}
              onChange={handleChange}
              required
              minLength={name === 'user_password' ? 8 : undefined}
              style={{ width: '100%', padding: '0.5rem' }}
            />
          </div>
        ))}

        <button type="submit" style={{ padding: '0.75rem 1.5rem' }}>Create Account</button>
        {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}
      </form>
    </div>
  );
};

export default Signup;